{
  "assets": [],
  "ddd": 0,
  "fr": 30,
  "h": 500,
  "ip": 0,
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "편지 위 1",
      "hd": false,
      "sr": 1,
      "ks": {
        "a": { "a": 0, "k": [188.884, 141.889] },
        "o": { "a": 0, "k": 100 },
        "p": { "a": 0, "k": [254.183, 268.01] },
        "r": { "a": 0, "k": 0 },
        "s": {
          "a": 1,
          "k": [
            { "t": 0, "s": [100, 100], "i": { "x": 0.56, "y": 1 }, "o": { "x": 0.44, "y": 0 } },
            { "t": 6, "s": [100, 0], "i": { "x": 0.5, "y": 1 }, "o": { "x": 0.12, "y": 0.23 } },
            { "t": 172.8, "s": [100, 0], "i": { "x": 0.56, "y": 1 }, "o": { "x": 0.44, "y": 0 } },
            { "t": 176.1, "s": [100, 100], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 }
      },
      "ao": 0,
      "ip": 0,
      "op": 196,
      "st": 0,
      "bm": 0,
      "shapes": [
        {
          "ty": "sh",
          "hd": false,
          "nm": "편지 위 1",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "i": [
                [0, 0],
                [0, 0],
                [0, 0],
                [4.005, 2.89]
              ],
              "o": [
                [0, 0],
                [0, 0],
                [-4.001, 2.895],
                [0, 0]
              ],
              "v": [
                [30.701, 142.273],
                [343.701, 142.273],
                [194.131, 250.493],
                [180.719, 250.502]
              ]
            }
          }
        },
        { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.424, 0.612, 0.98] }, "r": 1, "o": { "a": 0, "k": 100 } }
      ]
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "편지 아래",
      "hd": false,
      "sr": 1,
      "ks": {
        "a": { "a": 0, "k": [0, 0] },
        "o": { "a": 0, "k": 100 },
        "p": { "a": 0, "k": [65.299, 127.121] },
        "r": { "a": 0, "k": 0 },
        "s": { "a": 0, "k": [100, 100] },
        "sk": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 }
      },
      "ao": 0,
      "ip": 0,
      "op": 196,
      "st": 0,
      "bm": 0,
      "shapes": [
        {
          "ty": "sh",
          "hd": false,
          "nm": "편지 아래",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "i": [
                [0, 0],
                [0, 0],
                [0, 0],
                [-2.133, -1.576]
              ],
              "o": [
                [0, 0],
                [0, 0],
                [2.133, -1.576],
                [0, 0]
              ],
              "v": [
                [342.203, 344.45],
                [32.199, 344.45],
                [183.612, 232.535],
                [190.79, 232.535]
              ]
            }
          }
        },
        { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.655, 0.769, 0.988] }, "r": 1, "o": { "a": 0, "k": 100 } }
      ]
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "\b편지 오른쪽",
      "hd": false,
      "sr": 1,
      "ks": {
        "a": { "a": 0, "k": [0, 0] },
        "o": { "a": 0, "k": 100 },
        "p": { "a": 0, "k": [65.299, 127.121] },
        "r": { "a": 0, "k": 0 },
        "s": { "a": 0, "k": [100, 100] },
        "sk": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 }
      },
      "ao": 0,
      "ip": 0,
      "op": 196,
      "st": 0,
      "bm": 0,
      "shapes": [
        {
          "ty": "sh",
          "hd": false,
          "nm": "\b편지 오른쪽",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "i": [
                [0, 0],
                [0, 0],
                [0, 0]
              ],
              "o": [
                [0, 0],
                [0, 0],
                [0, 0]
              ],
              "v": [
                [30.701, 344.45],
                [30.701, 142.273],
                [343.701, 344.45]
              ]
            }
          }
        },
        { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.769, 0.843, 0.992] }, "r": 1, "o": { "a": 0, "k": 100 } }
      ]
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "편지 왼쪽",
      "hd": false,
      "sr": 1,
      "ks": {
        "a": { "a": 0, "k": [0, 0] },
        "o": { "a": 0, "k": 100 },
        "p": { "a": 0, "k": [65.299, 127.121] },
        "r": { "a": 0, "k": 0 },
        "s": { "a": 0, "k": [100, 100] },
        "sk": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 }
      },
      "ao": 0,
      "ip": 0,
      "op": 196,
      "st": 0,
      "bm": 0,
      "shapes": [
        {
          "ty": "sh",
          "hd": false,
          "nm": "편지 왼쪽",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "i": [
                [0, 0],
                [0, 0],
                [0, 0]
              ],
              "o": [
                [0, 0],
                [0, 0],
                [0, 0]
              ],
              "v": [
                [343.701, 344.45],
                [343.701, 142.273],
                [30.701, 344.45]
              ]
            }
          }
        },
        { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.769, 0.843, 0.992] }, "r": 1, "o": { "a": 0, "k": 100 } }
      ]
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 4,
      "nm": "말풍선1",
      "hd": false,
      "sr": 1,
      "ks": {
        "a": { "a": 0, "k": [74.874, 57.837] },
        "o": {
          "a": 1,
          "k": [
            { "t": 0, "s": [100], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
            { "t": 171.3, "s": [100], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
            { "t": 175.5, "s": [0], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
          ]
        },
        "p": {
          "a": 1,
          "k": [
            { "t": 0, "s": [368.749, 291.673], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
            { "t": 169.2, "s": [368.749, 288.673], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 }, "ti": [0, 0], "to": [0, 0] },
            { "t": 175.5, "s": [368.749, 407.673], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "s": {
          "a": 1,
          "k": [
            { "t": 0, "s": [0, 0], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
            { "t": 9, "s": [0, 0], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
            { "t": 21, "s": [100, 100], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 }
      },
      "ao": 0,
      "ip": 0,
      "op": 196,
      "st": 0,
      "bm": 0,
      "shapes": [
        {
          "ty": "gr",
          "hd": false,
          "nm": "시계 Group",
          "bm": 0,
          "it": [
            {
              "ty": "sh",
              "hd": false,
              "nm": "시계",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": false,
                  "i": [
                    [0, 0],
                    [-8.685, 0],
                    [0, 8.685],
                    [8.685, 0],
                    [0, -8.685]
                  ],
                  "o": [
                    [0, 8.685],
                    [8.685, 0],
                    [0, -8.685],
                    [-8.685, 0],
                    [0, 0]
                  ],
                  "v": [
                    [227.611, 218.35],
                    [243.337, 234.075],
                    [259.063, 218.35],
                    [243.337, 202.623],
                    [227.611, 218.35]
                  ]
                }
              }
            },
            { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.424, 0.612, 0.98] }, "r": 1, "o": { "a": 0, "k": 100 } },
            {
              "ty": "tr",
              "nm": "Transform",
              "a": { "a": 0, "k": [243.337, 218.349] },
              "o": { "a": 0, "k": 100 },
              "p": { "a": 0, "k": [41.514, -6.976] },
              "r": { "a": 0, "k": 0 },
              "s": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0, 0], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
                  { "t": 42, "s": [0, 0], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 48, "s": [100, 100], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
                ]
              },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "np": 0
        },
        {
          "ty": "gr",
          "hd": false,
          "nm": "메모지 Group",
          "bm": 0,
          "it": [
            {
              "ty": "gr",
              "hd": false,
              "nm": "Path 1 Group",
              "bm": 0,
              "it": [
                {
                  "ty": "sh",
                  "hd": false,
                  "nm": "Path 1",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": false,
                      "i": [
                        [0, 0],
                        [0, 0],
                        [-0.148, -0.01],
                        [0, 0],
                        [-0.048, 0.693],
                        [0, 0],
                        [0.693, 0.048],
                        [0, 0],
                        [0.048, -0.693],
                        [0, 0],
                        [-0.481, -0.215]
                      ],
                      "o": [
                        [0, 0],
                        [0.135, 0.061],
                        [0, 0],
                        [0.693, 0.048],
                        [0, 0],
                        [0.048, -0.693],
                        [0, 0],
                        [-0.693, -0.048],
                        [0, 0],
                        [-0.037, 0.526],
                        [0, 0]
                      ],
                      "v": [
                        [146.187, 219.843],
                        [162.61, 227.22],
                        [163.038, 227.327],
                        [171.078, 227.884],
                        [172.419, 226.716],
                        [173.876, 205.694],
                        [172.708, 204.352],
                        [147.816, 202.627],
                        [146.474, 203.795],
                        [145.448, 218.608],
                        [146.187, 219.843]
                      ]
                    }
                  }
                },
                { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.424, 0.612, 0.98] }, "r": 1, "o": { "a": 0, "k": 100 } },
                {
                  "ty": "tr",
                  "nm": "Transform",
                  "a": { "a": 0, "k": [0, 0] },
                  "o": { "a": 0, "k": 100 },
                  "p": { "a": 0, "k": [-158.457, -218.32] },
                  "r": { "a": 0, "k": 0 },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "np": 0
            },
            {
              "ty": "gr",
              "hd": false,
              "nm": "Path 1 Group",
              "bm": 0,
              "it": [
                {
                  "ty": "sh",
                  "hd": false,
                  "nm": "Path 1",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [-0.684, 0.122],
                        [0, 0],
                        [-0.122, -0.684],
                        [0, 0],
                        [0.684, -0.122],
                        [0, 0],
                        [0.122, 0.684]
                      ],
                      "o": [
                        [-0.122, -0.684],
                        [0, 0],
                        [0.684, -0.122],
                        [0, 0],
                        [0.122, 0.684],
                        [0, 0],
                        [-0.684, 0.122],
                        [0, 0]
                      ],
                      "v": [
                        [143.056, 212.524],
                        [144.073, 211.065],
                        [168.304, 206.747],
                        [169.763, 207.764],
                        [173.408, 228.218],
                        [172.391, 229.677],
                        [148.16, 233.996],
                        [146.7, 232.978]
                      ]
                    }
                  }
                },
                { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.424, 0.612, 0.98] }, "r": 1, "o": { "a": 0, "k": 100 } },
                {
                  "ty": "tr",
                  "nm": "Transform",
                  "a": { "a": 0, "k": [0, 0] },
                  "o": { "a": 0, "k": 100 },
                  "p": { "a": 0, "k": [-158.457, -218.32] },
                  "r": { "a": 0, "k": 0 },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "np": 0
            },
            {
              "ty": "tr",
              "nm": "Transform",
              "a": { "a": 0, "k": [0, 0] },
              "o": { "a": 0, "k": 100 },
              "p": { "a": 0, "k": [-43.366, -7.005] },
              "r": { "a": 0, "k": 0 },
              "s": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0, 0], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
                  { "t": 30, "s": [0, 0], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 36, "s": [100, 100], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
                ]
              },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "np": 0
        },
        {
          "ty": "gr",
          "hd": false,
          "nm": "전구 Group",
          "bm": 0,
          "it": [
            {
              "ty": "gr",
              "hd": false,
              "nm": "Path 1 (3) Group",
              "bm": 0,
              "it": [
                {
                  "ty": "sh",
                  "hd": false,
                  "nm": "Path 1 (3)",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [-0.695, 0],
                        [0, 0],
                        [0, -0.695],
                        [0, 0],
                        [0.511, -0.16],
                        [0, -0.043],
                        [0.58, 0],
                        [0, 0],
                        [2.656, 1.533],
                        [0, 1.423],
                        [0, 0],
                        [-0.077, 0.626],
                        [-0.001, 0.55]
                      ],
                      "o": [
                        [0, -0.695],
                        [0, 0],
                        [0.695, 0],
                        [0, 0],
                        [0, 0.563],
                        [0.005, 0.042],
                        [0, 0.579],
                        [0, 0],
                        [0, 3.067],
                        [-1.232, -0.712],
                        [0, 0],
                        [-0.631, 0],
                        [-0.526, -0.163],
                        [0, 0]
                      ],
                      "v": [
                        [193.57, 226.849],
                        [194.828, 225.591],
                        [205.43, 225.591],
                        [206.689, 226.849],
                        [206.689, 227.657],
                        [205.806, 228.857],
                        [205.814, 228.985],
                        [204.764, 230.035],
                        [204.053, 230.035],
                        [198.078, 233.485],
                        [196.086, 230.035],
                        [195.494, 230.035],
                        [194.452, 228.857],
                        [193.57, 227.657]
                      ]
                    }
                  }
                },
                { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.424, 0.612, 0.98] }, "r": 1, "o": { "a": 0, "k": 100 } },
                {
                  "ty": "tr",
                  "nm": "Transform",
                  "a": { "a": 0, "k": [0, 121.535] },
                  "o": { "a": 0, "k": 100 },
                  "p": { "a": 0, "k": [-200.374, -96.765] },
                  "r": { "a": 0, "k": 0 },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "np": 0
            },
            {
              "ty": "gr",
              "hd": false,
              "nm": "Path 1 (2) Group",
              "bm": 0,
              "it": [
                {
                  "ty": "sh",
                  "hd": false,
                  "nm": "Path 1 (2)",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": false,
                      "i": [
                        [0, 0],
                        [5.926, 0.062],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -5.939],
                        [-1, -1.64],
                        [0, 0],
                        [-0.01, -0.495],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-3.374, 5.401],
                        [0, 0],
                        [0.003, 1.986]
                      ],
                      "o": [
                        [0, -5.939],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-5.924, 0.062],
                        [0, 2.061],
                        [0, 0],
                        [3.376, 5.401],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.011, -0.496],
                        [0, 0],
                        [1.035, -1.695],
                        [0, 0]
                      ],
                      "v": [
                        [212.143, 213.397],
                        [201.43, 202.575],
                        [201.43, 202.572],
                        [201.315, 202.572],
                        [201.315, 202.575],
                        [190.605, 213.397],
                        [192.182, 219.026],
                        [192.176, 219.026],
                        [195.778, 227.784],
                        [195.778, 227.862],
                        [206.969, 227.862],
                        [206.969, 227.784],
                        [210.571, 219.026],
                        [210.565, 219.026],
                        [212.143, 213.397]
                      ]
                    }
                  }
                },
                { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.424, 0.612, 0.98] }, "r": 1, "o": { "a": 0, "k": 100 } },
                {
                  "ty": "tr",
                  "nm": "Transform",
                  "a": { "a": 0, "k": [0, 0] },
                  "o": { "a": 0, "k": 100 },
                  "p": { "a": 0, "k": [-201.374, -218.295] },
                  "r": { "a": 0, "k": 0 },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "np": 0
            },
            {
              "ty": "tr",
              "nm": "Transform",
              "a": { "a": 0, "k": [0, 0] },
              "o": { "a": 0, "k": 100 },
              "p": { "a": 0, "k": [-0.501, -7.031] },
              "r": { "a": 0, "k": 0 },
              "s": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0, 0], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
                  { "t": 36, "s": [0, 0], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 42, "s": [100, 100], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
                ]
              },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "np": 0
        },
        {
          "ty": "gr",
          "hd": false,
          "nm": "말풍선 3 Group",
          "bm": 0,
          "it": [
            {
              "ty": "gr",
              "hd": false,
              "nm": "Path 1 Group",
              "bm": 0,
              "it": [
                {
                  "ty": "sh",
                  "hd": false,
                  "nm": "Path 1",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [2.091, 1.779],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0.589, 2.683],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [261.138, 279.69],
                        [256.48, 282.489],
                        [239.276, 267.851],
                        [256.294, 257.627]
                      ]
                    }
                  }
                },
                { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.169, 0.243, 0.392] }, "r": 1, "o": { "a": 0, "k": 100 } },
                {
                  "ty": "tr",
                  "nm": "Transform",
                  "a": { "a": 0, "k": [0, 0] },
                  "o": { "a": 0, "k": 100 },
                  "p": { "a": 0, "k": [-201.114, -225.346] },
                  "r": { "a": 0, "k": 0 },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "np": 0
            },
            {
              "ty": "gr",
              "hd": false,
              "nm": "Path 1 Group",
              "bm": 0,
              "it": [
                {
                  "ty": "sh",
                  "hd": false,
                  "nm": "Path 1",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, -4.75],
                        [0, 0],
                        [4.75, 0],
                        [0, 0],
                        [0, 4.75],
                        [0, 0],
                        [-4.75, 0]
                      ],
                      "o": [
                        [0, 0],
                        [4.75, 0],
                        [0, 0],
                        [0, 4.75],
                        [0, 0],
                        [-4.75, 0],
                        [0, 0],
                        [0, -4.75],
                        [0, 0]
                      ],
                      "v": [
                        [134.84, 167.51],
                        [267.388, 167.51],
                        [275.988, 176.11],
                        [275.988, 261.319],
                        [267.388, 269.919],
                        [134.84, 269.919],
                        [126.24, 261.319],
                        [126.24, 176.11],
                        [134.84, 167.51]
                      ]
                    }
                  }
                },
                { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.169, 0.243, 0.392] }, "r": 1, "o": { "a": 0, "k": 100 } },
                {
                  "ty": "tr",
                  "nm": "Transform",
                  "a": { "a": 0, "k": [0, 0] },
                  "o": { "a": 0, "k": 100 },
                  "p": { "a": 0, "k": [-201.114, -225.346] },
                  "r": { "a": 0, "k": 0 },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "np": 0
            },
            { "ty": "mm", "hd": false, "mm": 2 },
            { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.169, 0.243, 0.392] }, "r": 1, "o": { "a": 0, "k": 100 } },
            {
              "ty": "tr",
              "nm": "Transform",
              "a": { "a": 0, "k": [0, 0] },
              "o": { "a": 0, "k": 100 },
              "p": { "a": 0, "k": [0, 0] },
              "r": { "a": 0, "k": 0 },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "np": 0
        }
      ]
    },
    {
      "ddd": 0,
      "ind": 16,
      "ty": 4,
      "nm": "말풍선2",
      "hd": false,
      "sr": 1,
      "ks": {
        "a": { "a": 0, "k": [-90.816, 58.088] },
        "o": {
          "a": 1,
          "k": [
            { "t": 0, "s": [100], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
            { "t": 171.3, "s": [100], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
            { "t": 175.5, "s": [0], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
          ]
        },
        "p": {
          "a": 1,
          "k": [
            { "t": 0, "s": [122, 210.176], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
            { "t": 169.2, "s": [122, 207.176], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 }, "ti": [0, 0], "to": [0, 0] },
            { "t": 175.5, "s": [122, 326.176], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "s": {
          "a": 1,
          "k": [
            { "t": 0, "s": [0, 0], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
            { "t": 54, "s": [0, 0], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
            { "t": 60, "s": [100, 100], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 }
      },
      "ao": 0,
      "ip": 0,
      "op": 196,
      "st": 0,
      "bm": 0,
      "shapes": [
        {
          "ty": "gr",
          "hd": false,
          "nm": "1 Group",
          "bm": 0,
          "it": [
            {
              "ty": "sh",
              "hd": false,
              "nm": "1",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [2.85, 0],
                    [0, 2.85],
                    [-2.85, 0],
                    [0, -2.85]
                  ],
                  "o": [
                    [0, 2.85],
                    [-2.85, 0],
                    [0, -2.85],
                    [2.85, 0],
                    [0, 0]
                  ],
                  "v": [
                    [91.795, 149.475],
                    [86.634, 154.635],
                    [81.474, 149.475],
                    [86.634, 144.315],
                    [91.795, 149.475]
                  ]
                }
              }
            },
            { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [1, 1, 1] }, "r": 1, "o": { "a": 0, "k": 100 } },
            {
              "ty": "tr",
              "nm": "Transform",
              "a": { "a": 0, "k": [86.634, 149.475] },
              "o": { "a": 0, "k": 100 },
              "p": { "a": 0, "k": [-34.13, -3.984] },
              "r": { "a": 0, "k": 0 },
              "s": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [100, 100], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 60, "s": [100, 100], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 66.3, "s": [130, 130], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 72.3, "s": [100, 100], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
                ]
              },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "np": 0
        },
        {
          "ty": "gr",
          "hd": false,
          "nm": "2 Group",
          "bm": 0,
          "it": [
            {
              "ty": "sh",
              "hd": false,
              "nm": "2",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [2.85, 0],
                    [0, 2.85],
                    [-2.85, 0],
                    [0, -2.85]
                  ],
                  "o": [
                    [0, 2.85],
                    [-2.85, 0],
                    [0, -2.85],
                    [2.85, 0],
                    [0, 0]
                  ],
                  "v": [
                    [125.051, 149.475],
                    [119.89, 154.635],
                    [114.73, 149.475],
                    [119.89, 144.315],
                    [125.051, 149.475]
                  ]
                }
              }
            },
            { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [1, 1, 1] }, "r": 1, "o": { "a": 0, "k": 100 } },
            {
              "ty": "tr",
              "nm": "Transform",
              "a": { "a": 0, "k": [119.89, 149.475] },
              "o": { "a": 0, "k": 100 },
              "p": { "a": 0, "k": [-0.874, -3.984] },
              "r": { "a": 0, "k": 0 },
              "s": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [100, 100], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 72.3, "s": [100, 100], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 78.6, "s": [130, 130], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 84.6, "s": [100, 100], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
                ]
              },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "np": 0
        },
        {
          "ty": "gr",
          "hd": false,
          "nm": "3 Group",
          "bm": 0,
          "it": [
            {
              "ty": "sh",
              "hd": false,
              "nm": "3",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [2.85, 0],
                    [0, 2.85],
                    [-2.85, 0],
                    [0, -2.85]
                  ],
                  "o": [
                    [0, 2.85],
                    [-2.85, 0],
                    [0, -2.85],
                    [2.85, 0],
                    [0, 0]
                  ],
                  "v": [
                    [158.307, 149.475],
                    [153.146, 154.635],
                    [147.986, 149.475],
                    [153.146, 144.315],
                    [158.307, 149.475]
                  ]
                }
              }
            },
            { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [1, 1, 1] }, "r": 1, "o": { "a": 0, "k": 100 } },
            {
              "ty": "tr",
              "nm": "Transform",
              "a": { "a": 0, "k": [153.146, 149.475] },
              "o": { "a": 0, "k": 100 },
              "p": { "a": 0, "k": [32.382, -3.984] },
              "r": { "a": 0, "k": 0 },
              "s": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [100, 100], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 84.6, "s": [100, 100], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 90.9, "s": [130, 130], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 96.9, "s": [100, 100], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
                ]
              },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "np": 0
        },
        {
          "ty": "gr",
          "hd": false,
          "nm": "말풍선2 Group",
          "bm": 0,
          "it": [
            {
              "ty": "gr",
              "hd": false,
              "nm": "Path 1 Group",
              "bm": 0,
              "it": [
                {
                  "ty": "sh",
                  "hd": false,
                  "nm": "Path 1",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": false,
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0.503, 0.113],
                        [0, 0],
                        [0.08, -0.297],
                        [0, 0],
                        [-2.21, 1.346]
                      ],
                      "o": [
                        [0, 0],
                        [0.44, -0.268],
                        [0, 0],
                        [-0.3, -0.068],
                        [0, 0],
                        [-0.673, 2.499],
                        [0, 0]
                      ],
                      "v": [
                        [50.888, 211.119],
                        [82.842, 191.652],
                        [82.67, 190.604],
                        [53.624, 184.055],
                        [52.944, 184.465],
                        [46.627, 207.925],
                        [50.887, 211.119]
                      ]
                    }
                  }
                },
                { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.424, 0.612, 0.98] }, "r": 1, "o": { "a": 0, "k": 100 } },
                {
                  "ty": "tr",
                  "nm": "Transform",
                  "a": { "a": 0, "k": [0, 0] },
                  "o": { "a": 0, "k": 100 },
                  "p": { "a": 0, "k": [-120.765, -153.459] },
                  "r": { "a": 0, "k": 0 },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "np": 0
            },
            {
              "ty": "gr",
              "hd": false,
              "nm": "Path 1 Group",
              "bm": 0,
              "it": [
                {
                  "ty": "sh",
                  "hd": false,
                  "nm": "Path 1",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [50.156, 0],
                        [0, 29.88],
                        [-50.156, 0],
                        [0, -29.88]
                      ],
                      "o": [
                        [0, 29.88],
                        [-50.156, 0],
                        [0, -29.88],
                        [50.156, 0],
                        [0, 0]
                      ],
                      "v": [
                        [211.58, 149.474],
                        [120.765, 203.577],
                        [29.949, 149.474],
                        [120.765, 95.371],
                        [211.58, 149.474]
                      ]
                    }
                  }
                },
                { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.424, 0.612, 0.98] }, "r": 1, "o": { "a": 0, "k": 100 } },
                {
                  "ty": "tr",
                  "nm": "Transform",
                  "a": { "a": 0, "k": [0, 0] },
                  "o": { "a": 0, "k": 100 },
                  "p": { "a": 0, "k": [-120.765, -153.459] },
                  "r": { "a": 0, "k": 0 },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 }
                }
              ],
              "np": 0
            },
            { "ty": "mm", "hd": false, "mm": 2 },
            { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.424, 0.612, 0.98] }, "r": 1, "o": { "a": 0, "k": 100 } },
            {
              "ty": "tr",
              "nm": "Transform",
              "a": { "a": 0, "k": [0, 0] },
              "o": { "a": 0, "k": 100 },
              "p": { "a": 0, "k": [0, 0] },
              "r": { "a": 0, "k": 0 },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "np": 0
        }
      ]
    },
    {
      "ddd": 0,
      "ind": 23,
      "ty": 4,
      "nm": "말풍선1",
      "hd": false,
      "sr": 1,
      "ks": {
        "a": { "a": 0, "k": [129.299, 50.27] },
        "o": {
          "a": 1,
          "k": [
            { "t": 0, "s": [100], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
            { "t": 171, "s": [100], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
            { "t": 175.2, "s": [0], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
          ]
        },
        "p": {
          "a": 1,
          "k": [
            { "t": 0, "s": [380.597, 124.541], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
            { "t": 169.2, "s": [380.597, 121.541], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 }, "ti": [0, 0], "to": [0, 0] },
            { "t": 175.5, "s": [380.597, 240.541], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "s": {
          "a": 1,
          "k": [
            { "t": 0, "s": [0, 0], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
            { "t": 90.9, "s": [0, 0], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
            { "t": 103.2, "s": [100, 100], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 }
      },
      "ao": 0,
      "ip": 0,
      "op": 196,
      "st": 0,
      "bm": 0,
      "shapes": [
        {
          "ty": "gr",
          "hd": false,
          "nm": "문자 아래 Group",
          "bm": 0,
          "it": [
            {
              "ty": "sh",
              "hd": false,
              "nm": "문자 아래",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": false,
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [154.483, 78.86],
                    [249.905, 78.86]
                  ]
                }
              }
            },
            {
              "ty": "st",
              "hd": false,
              "bm": 0,
              "c": { "a": 0, "k": [1, 1, 1] },
              "lc": 2,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100 },
              "w": { "a": 0, "k": 7.134 }
            },
            {
              "ty": "tr",
              "nm": "Transform",
              "a": { "a": 0, "k": [251.071, 78.86] },
              "o": { "a": 0, "k": 100 },
              "p": { "a": 0, "k": [91.65, 3.102] },
              "r": { "a": 0, "k": 0 },
              "s": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0, 0], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
                  { "t": 109.2, "s": [0, 0], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 121.5, "s": [100, 100], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
                ]
              },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "np": 0
        },
        {
          "ty": "gr",
          "hd": false,
          "nm": "문자 위 Group",
          "bm": 0,
          "it": [
            {
              "ty": "sh",
              "hd": false,
              "nm": "문자 위",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": false,
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [69.573, 56.218],
                    [249.905, 56.218]
                  ]
                }
              }
            },
            {
              "ty": "st",
              "hd": false,
              "bm": 0,
              "c": { "a": 0, "k": [1, 1, 1] },
              "lc": 2,
              "lj": 1,
              "ml": 4,
              "o": { "a": 0, "k": 100 },
              "w": { "a": 0, "k": 7.134 }
            },
            {
              "ty": "tr",
              "nm": "Transform",
              "a": { "a": 0, "k": [249.905, 55.615] },
              "o": { "a": 0, "k": 100 },
              "p": { "a": 0, "k": [90.484, -20.144] },
              "r": { "a": 0, "k": 0 },
              "s": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0, 0], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
                  { "t": 96.9, "s": [0, 0], "i": { "x": 0.15, "y": 1.35 }, "o": { "x": 0.15, "y": 0.45 } },
                  { "t": 109.2, "s": [100, 100], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
                ]
              },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "np": 0
        },
        {
          "ty": "gr",
          "hd": false,
          "nm": "Path 1 Group",
          "bm": 0,
          "it": [
            {
              "ty": "sh",
              "hd": false,
              "nm": "Path 1",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [2.091, 1.779],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0.589, 2.683],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [261.137, 122.536],
                    [256.479, 125.335],
                    [239.275, 110.697],
                    [256.293, 100.473]
                  ]
                }
              }
            },
            { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.769, 0.843, 0.992] }, "r": 1, "o": { "a": 0, "k": 100 } },
            {
              "ty": "tr",
              "nm": "Transform",
              "a": { "a": 0, "k": [0, 0] },
              "o": { "a": 0, "k": 100 },
              "p": { "a": 0, "k": [-159.421, -75.759] },
              "r": { "a": 0, "k": 0 },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "np": 0
        },
        {
          "ty": "gr",
          "hd": false,
          "nm": "Path 1 Group",
          "bm": 0,
          "it": [
            {
              "ty": "sh",
              "hd": false,
              "nm": "Path 1",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, -23.599],
                    [0, 0],
                    [23.599, 0],
                    [0, 0],
                    [0, 23.599],
                    [0, 0],
                    [-23.599, 0]
                  ],
                  "o": [
                    [0, 0],
                    [23.599, 0],
                    [0, 0],
                    [0, 23.599],
                    [0, 0],
                    [-23.599, 0],
                    [0, 0],
                    [0, -23.599],
                    [0, 0]
                  ],
                  "v": [
                    [72.852, 25.488],
                    [245.99, 25.488],
                    [288.719, 68.218],
                    [288.719, 68.218],
                    [245.99, 110.947],
                    [72.852, 110.947],
                    [30.122, 68.218],
                    [30.122, 68.218],
                    [72.852, 25.488]
                  ]
                }
              }
            },
            { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.769, 0.843, 0.992] }, "r": 1, "o": { "a": 0, "k": 100 } },
            {
              "ty": "tr",
              "nm": "Transform",
              "a": { "a": 0, "k": [0, 0] },
              "o": { "a": 0, "k": 100 },
              "p": { "a": 0, "k": [-159.421, -75.759] },
              "r": { "a": 0, "k": 0 },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 }
            }
          ],
          "np": 0
        },
        { "ty": "mm", "hd": false, "mm": 2 },
        { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [0.769, 0.843, 0.992] }, "r": 1, "o": { "a": 0, "k": 100 } }
      ]
    },
    {
      "ddd": 0,
      "ind": 28,
      "ty": 4,
      "nm": "편지 위 2",
      "hd": false,
      "sr": 1,
      "ks": {
        "a": { "a": 0, "k": [187.416, 143.414] },
        "o": { "a": 0, "k": 100 },
        "p": { "a": 0, "k": [252.285, 268.253] },
        "r": { "a": 0, "k": 180 },
        "s": {
          "a": 1,
          "k": [
            { "t": 0, "s": [0, 0], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
            { "t": 4.5, "s": [100, 0], "i": { "x": 0.56, "y": 1 }, "o": { "x": 0.44, "y": 0 } },
            { "t": 12, "s": [100, 100], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
            { "t": 170.7, "s": [100, 100], "i": { "x": 0.56, "y": 1 }, "o": { "x": 0.44, "y": 0 } },
            { "t": 174.9, "s": [100, 0], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 }
      },
      "ao": 0,
      "ip": 0,
      "op": 196,
      "st": 0,
      "bm": 0,
      "shapes": [
        {
          "ty": "sh",
          "hd": false,
          "nm": "편지 위 2",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "i": [
                [0, 0],
                [0, 0],
                [0, 0],
                [4.005, 2.89]
              ],
              "o": [
                [0, 0],
                [0, 0],
                [-4.001, 2.895],
                [0, 0]
              ],
              "v": [
                [30.701, 142.273],
                [343.701, 142.273],
                [194.131, 250.493],
                [180.719, 250.502]
              ]
            }
          }
        },
        { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [1, 1, 1] }, "r": 1, "o": { "a": 0, "k": 100 } }
      ]
    },
    {
      "ddd": 0,
      "ind": 29,
      "ty": 4,
      "nm": "편지바닥",
      "hd": false,
      "sr": 1,
      "ks": {
        "a": { "a": 0, "k": [0, 0] },
        "o": { "a": 0, "k": 100 },
        "p": {
          "a": 1,
          "k": [
            { "t": 0, "s": [65.299, 127.121], "i": { "x": 0.75, "y": 0.75 }, "o": { "x": 0.25, "y": 0.25 } },
            { "t": 181.8, "s": [65.299, 128.121], "i": { "x": 0, "y": 0 }, "o": { "x": 1, "y": 1 } }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "s": { "a": 0, "k": [100, 100] },
        "sk": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 }
      },
      "ao": 0,
      "ip": 0,
      "op": 196,
      "st": 0,
      "bm": 0,
      "shapes": [
        {
          "ty": "sh",
          "hd": false,
          "nm": "편지바닥",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "i": [
                [0, 0],
                [0, 0],
                [0, 0],
                [2.817, 2.49]
              ],
              "o": [
                [0, 0],
                [0, 0],
                [-2.813, 2.494],
                [0, 0]
              ],
              "v": [
                [30.701, 140.775],
                [343.701, 140.775],
                [192.356, 274.935],
                [182.495, 274.943]
              ]
            }
          }
        },
        { "ty": "fl", "hd": false, "bm": 0, "c": { "a": 0, "k": [1, 1, 1] }, "r": 1, "o": { "a": 0, "k": 100 } }
      ]
    }
  ],
  "meta": { "g": "@phase-software/lottie-exporter 0.7.0" },
  "nm": "",
  "op": 195,
  "v": "5.6.0",
  "w": 500
}
